import styled from 'styled-components';
import type { Variation } from './TimeOffCard.component';

export const ButtonCard = styled.button`
  background-color: ${({ theme }) => theme.colors['neutral-0']};
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.colors['neutral-40']};
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.12);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 20%;
  align-items: center;
`;

export const ButtonCardText = styled.p<{ $empty?: boolean }>`
  color: ${({ theme, $empty = false }) => ($empty ? '#ABACAF' : theme.colors['neutral-100'])};
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
`;

export const ButtonHoursContainer = styled.div<{ $variation: Variation }>`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;

  & > svg {
    width: 25px;
    height: 25px;
    color: ${({ theme, $variation }) =>
      $variation === 'neutral' ? theme.colors['neutral-100'] : theme.colors['primary-60']};
  }

  & > p {
    color: ${({ theme, $variation }) =>
      $variation === 'neutral' ? theme.colors['neutral-100'] : theme.colors['primary-60']};
    font-size: 26px;
    font-weight: 600;
    line-height: 120%;
  }
`;

export const ButtonHoursAvailable = styled.p<{ $variation: Variation }>`
  color: ${({ theme, $variation }) =>
    $variation === 'neutral' ? theme.colors['neutral-100'] : theme.colors['primary-60']};
  font-size: 14px;
  font-weight: 600;
  line-height: 150%;
`;
